import React from "react";

export const ErrorIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="ic_highlight_off_48px" clip-path="url(#clip0_1721_22484)">
                <path
                    id="Vector"
                    d="M14.585 8L12 10.585L9.415 8L8 9.415L10.585 12L8 14.585L9.415 16L12 13.415L14.585 16L16 14.585L13.415 12L16 9.415L14.585 8ZM12 2C6.475 2 2 6.475 2 12C2 17.525 6.475 22 12 22C17.525 22 22 17.525 22 12C22 6.475 17.525 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
                    fill="#DA001A"
                />
            </g>
            <defs>
                <clipPath id="clip0_1721_22484">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
